import { api } from "./api";

// ----- Order-centric (refactor 2026-02-22) -----
export async function getAccountingKpis(params = {}) {
  const { data } = await api.get("/accounting/kpis", { params }); return data;
}
export async function listAccountingOrders(params = {}) {
  const { data } = await api.get("/accounting/orders", { params }); return data;
}
export async function getAccountingOrder(orderId) {
  const { data } = await api.get(`/accounting/orders/${orderId}`); return data;
}
export async function backfillInvoiceLinks(onlyMissing = true) {
  const { data } = await api.post(`/accounting/invoices/backfill-shopify-link?only_missing=${onlyMissing}`);
  return data;
}
export function exportOrdersUrl(format = "xlsx", params = {}) {
  // Build a query string compatible with axios default base URL
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const base = api.defaults.baseURL?.replace(/\/$/, "") || "";
  return `${base}/accounting/export.${format}?${qs.toString()}`;
}
export async function downloadExport(format, params = {}) {
  const { data } = await api.get(`/accounting/export.${format}`, {
    params,
    responseType: "blob",
  });
  return data;
}

// ----- Excepții + Import GLS (Phase 1 — kept intact) -----
export async function listExceptions(limit = 200) {
  const { data } = await api.get(`/accounting/exceptions?limit=${limit}`); return data;
}
export async function listImports(params = {}) {
  const { data } = await api.get("/accounting/imports", { params }); return data;
}
export async function uploadGlsXlsx(file, onProgress) {
  const form = new FormData(); form.append("file", file);
  const { data } = await api.post("/accounting/imports/gls", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress?.(Math.round((100 * e.loaded) / (e.total || 1))),
  });
  return data;
}
export async function deleteImport(id) {
  const { data } = await api.delete(`/accounting/imports/${id}`); return data;
}
export async function recomputeImport(id) {
  const { data } = await api.post(`/accounting/imports/${id}/recompute`); return data;
}
export async function reconcileAll() {
  const { data } = await api.post(`/accounting/reconcile-all`); return data;
}
export async function markBatchPaid(batchId) {
  const { data } = await api.post(`/accounting/imports/${batchId}/mark-all-paid`);
  return data;
}

// ----- SmartBill XLSX import -----
export async function uploadSmartBillXlsx(file, onProgress) {
  const form = new FormData(); form.append("file", file);
  const { data } = await api.post("/accounting/smartbill-imports", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress?.(Math.round((100 * e.loaded) / (e.total || 1))),
  });
  return data;
}
export async function listSmartBillImports(params = {}) {
  const { data } = await api.get("/accounting/smartbill-imports", { params }); return data;
}

// ----- SmartBill unmatched (Necorelate tab) -----
export async function reclassifyStorno({ dryRun = false } = {}) {
  const { data } = await api.post(
    `/accounting/smartbill-imports/reclassify-storno${dryRun ? "?dry_run=true" : ""}`,
  );
  return data;
}
export async function listSmartBillUnmatched(params = {}) {
  const { data } = await api.get("/accounting/smartbill-unmatched", { params }); return data;
}
export async function searchShopifyOrders(q, limit = 20) {
  const { data } = await api.get("/accounting/shopify-orders/search", { params: { q, limit } });
  return data.items || [];
}
export async function linkInvoiceToOrder(invoiceId, orderId) {
  const { data } = await api.post(`/accounting/smartbill-invoices/${invoiceId}/link`, {
    order_id: orderId,
  });
  return data;
}
export function unmatchedExportUrl(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v);
  });
  const base = api.defaults.baseURL?.replace(/\/$/, "") || "";
  return `${base}/accounting/smartbill-unmatched/export.xlsx?${qs.toString()}`;
}
export async function downloadUnmatchedExport(params = {}) {
  const { data } = await api.get("/accounting/smartbill-unmatched/export.xlsx", {
    params, responseType: "blob",
  });
  return data;
}
